import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";

import FormListItem from "~/components/me/bento/content/committed-database/FormListItem";
import { buildLatestRespondedForms } from "~/components/me/bento/content/committed-database/lib";
import { SP_MODE_WIDTH } from "~/lib/client/hooks/useIsSpMode";
import { MeCommittedDatabaseQuery } from "~/lib/graphql/client";

const DialogBody = ({ content }: { content: MeCommittedDatabaseQuery }) => {
  const theme = useTheme();

  const responses = content.me.responses;
  const latestRespondedForms = buildLatestRespondedForms(responses);

  return (
    <div css={rootStyle}>
      <div css={formsContainerStyle(theme)}>
        {latestRespondedForms.map((form) => (
          <FormListItem {...form} key={form.id} />
        ))}
      </div>
    </div>
  );
};

const rootStyle = css`
  padding: 2rem;

  @media (max-width: ${SP_MODE_WIDTH}px) {
    padding: 0;
    margin-right: -1rem;
    margin-left: -1rem;
  }
`;

const formsContainerStyle = (theme: Theme) => css`
  display: flex;
  margin-top: 0.5rem;
  margin-left: 1rem;
  margin-right: 1rem;
  flex-direction: column;
  padding-right: 1rem;
  padding-left: 1rem;
  background: ${theme.palette.background.default};
  border-radius: 20px;

  a {
    border-bottom: 1px solid ${theme.palette.divider};

    &:last-child {
      border-bottom: none;
    }
  }

  @media (max-width: ${SP_MODE_WIDTH}px) {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
`;

/**
 * @package
 */
export default DialogBody;
